import { render } from "./LoadingDots.vue?vue&type=template&id=36ee6b45&scoped=true"
const script = {}

import "./LoadingDots.vue?vue&type=style&index=0&id=36ee6b45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ee6b45"]])

export default __exports__